import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import i18n from '@/application/i18n/config'

type Language = 'en' | 'de'

type AppStore = {
  isDarkMode?: boolean
  language: Language
  toggleMode: () => void
  setLanguage: (language: Language) => void
}

export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      isDarkMode: false,
      language: (i18n.language as Language) || 'en',
      toggleMode: () =>
        set((state) => {
          return { isDarkMode: !state.isDarkMode }
        }),
      setLanguage: (language: Language) => {
        i18n.changeLanguage(language)
        set({ language })
      }
    }),
    {
      name: 'app-storage', // localStorage key
      partialize: (state) => ({
        isDarkMode: state.isDarkMode,
        language: state.language
      })
    }
  )
)
